var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { staticClass: "product-card", attrs: { href: _vm.link } }, [
    _c("div", { staticClass: "image-padding" }, [
      _c("div", { staticClass: "image-wrapper" }, [
        _c("img", {
          staticClass: "lazyload",
          attrs: { "data-src": _vm.firstImage, alt: _vm.title }
        }),
        _vm._v(" "),
        _vm.isTop
          ? _c("span", { staticClass: "top-label" }, [_vm._v("Topaanbieding")])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-wrapper" }, [
      _c("div", { staticClass: "top-content" }, [
        _c("h3", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("div", {
          staticClass: "description",
          domProps: { innerHTML: _vm._s(_vm.description) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pricing" }, [
        _c("span", [_vm._v("vanaf")]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "price" }, [
            _vm._v(
              "€ " +
                _vm._s(
                  _vm.getLowestPrice(_vm.$store.getters["pricesIncludingVat"])
                )
            )
          ]),
          _vm._v(" "),
          _vm.$store.getters["pricesIncludingVat"]
            ? _c("span", [_vm._v("incl. btw")])
            : _c("span", [_vm._v("excl. btw")])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "price-secondary" }, [
            _vm._v(
              "€ " +
                _vm._s(
                  _vm.getLowestPrice(!_vm.$store.getters["pricesIncludingVat"])
                )
            )
          ]),
          _vm._v(" "),
          !_vm.$store.getters["pricesIncludingVat"]
            ? _c("span", [_vm._v("incl. btw")])
            : _c("span", [_vm._v("excl. btw")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }